/**
 * 상태 해시. 서버가 리플레이를 재생한 뒤 클라이언트가 보고한 결과와 맞춰보는 데 쓴다.
 * FNV-1a 32비트. 암호학적 용도가 아니라 불일치 감지용이다.
 */
const FNV_OFFSET = 0x811c9dc5;
const FNV_PRIME = 0x01000193;

export function hashInit(): number {
  return FNV_OFFSET;
}

export function hashNumber(h: number, v: number): number {
  let x = h;
  const n = v | 0;
  for (let s = 0; s < 32; s += 8) {
    x ^= (n >>> s) & 0xff;
    x = Math.imul(x, FNV_PRIME);
  }
  return x >>> 0;
}

export function hashArray(
  h: number,
  arr: Int32Array | Int16Array | Uint8Array | Uint16Array,
  count: number,
): number {
  let x = h;
  const n = Math.min(count, arr.length);
  for (let i = 0; i < n; i++) x = hashNumber(x, arr[i]);
  return x >>> 0;
}

export function hashToHex(h: number): string {
  return (h >>> 0).toString(16).padStart(8, '0');
}
